import React, { useState } from 'react';
import styles from './AddIngredients.module.css';
import LoaderPage from '../LoaderPage/LoaderPage';
import CloseBtn from '../../elemets/CloseBtn/CloseBtn';
import { ArrowBottomSvg, ListSvg } from '../../SVGComponents/SVGComponents';
import Checkbox from '../../elemets/Checkbox/Checkbox';
import { addDocBd } from '../../firebase';
import { bodyScrollOverflowAuto, generateRandomString } from '../../helper';
import { getObjectIngredient } from '../../helperProject';
import ProductList from '../ProductList/ProductList';
import SimilarData from '../SimilarData/SimilarData';
import ListBtn from '../../elemets/ListBtn/ListBtn';
import NutritionalValue from '../NutritionalValue/NutritionalValue';

export default function AddIngredients({
  setPopup,
  products,
  ingredientsArray,
  setIngredientsArray,
  ingredientEdit = null,
  setIngredientEdit,
}) {
  const [loader, setLoader] = useState(false);
  const [showUnitsListIngredient, setShowUnitsListIngredient] = useState(false);
  const [showRoundingIngredientList, setShowRoundingIngredientList] = useState(false);
  const [showRoundingProductBasketList, setShowRoundingProductBasketList] = useState(false);
  const [showUnitsListProducts, setShowUnitsListProducts] = useState(false);
  const [showProducsList, setShowProducsList] = useState(false);
  const [showSimilarData, setShowSimilarData] = useState(false);

  const defaultObject = ingredientEdit ? ingredientEdit : getObjectIngredient();

  const [ingredientObject, setIngredientObject] = useState(defaultObject);

  const unitsIngredient = [
    {
      id: 1,
      unitText: 'г',
    },
    {
      id: 2,
      unitText: 'мл',
    },
    {
      id: 3,
      unitText: 'шт',
    },
    {
      id: 4,
      unitText: 'ч.л',
    },

    {
      id: 5,
      unitText: 'ст.л',
    },

    {
      id: 6,
      unitText: 'за смаком',
    },
  ];
  const roundinIngredients = [
    {
      id: 1,
      roundinText: 'До найближчого цілого',
      roundin: 'round',
    },
    {
      id: 2,
      roundinText: 'До найближчого кратного 5',
      roundin: 5,
    },
    {
      id: 3,
      roundinText: 'До найближчого кратного 0.5',
      roundin: 0.5,
    },
    {
      id: 4,
      roundinText: 'До меншого цілого',
      roundin: 'floor',
    },
    {
      id: 5,
      roundinText: 'До більшого цілого',
      roundin: 'ceil',
    },
    {
      id: 6,
      roundinText: 'До десятих',
      roundin: 'toFixed',
    },
  ];
  const unitsProducts = [
    {
      id: 1,
      unitText: 'г',
    },
    {
      id: 2,
      unitText: 'мл',
    },
    {
      id: 3,
      unitText: 'шт',
    },
  ];

  const addIngredients = async (ingredientObject) => {
    setLoader(true);

    if (!ingredientObject.textIngredientDefault) {
      window.alert('Заповніть назву інгридієнта!');
      setLoader(false);
      return;
    }
    // if (!ingredientObject.unitText) {
    //   window.alert('Виберіть в чому буде вимірюватись!');
    //   setLoader(false);
    //   return;
    // }

    // if (ingredientObject.ifAddBasket && !ingredientObject.textBasketProductNameDefault) {
    //   window.alert('Додайте назву продукту в кошику!');
    //   setLoader(false);
    //   return;
    // }

    const data = {
      ...ingredientObject,
      textIngredientDefault: ingredientObject.textIngredientDefault.trim(),
      сaloriesIngredient: '',
      proteinIngredient: '',
      fatsIngredient: '',
      carbohydratesIngredient: '',
      onChangeIngredientValue: '',
      onChangeIngredientValueRoundin: '',
    };

    // console.log(data);

    const isAddIngredient = await addDocBd('ingredients', data.id, {
      ...data,
      newIngredient: false,
    });

    if (isAddIngredient) {
      data.newIngredient = true;
      // Якщо редагуємо інгридієнт
      if (ingredientEdit) {
        // Змаміняєм старий обєкт новим відредагованим
        for (let index = 0; index < ingredientsArray.length; index++) {
          const item = ingredientsArray[index];
          if (data.id === item.id) {
            ingredientsArray.splice(index, 1, data);
            setIngredientsArray(ingredientsArray);
            break;
          }
        }
        alert('Інгридієнт змінено успішно.');
      } else {
        // Додаєм новий інгридієнт на початок
        setIngredientsArray([data, ...ingredientsArray]);
        alert('Інгридієнт додано успішно.');
      }
    } else {
      alert('Помилка інгридієнт не було додано!!!!');
    }
    bodyScrollOverflowAuto();
    setIngredientEdit(null);
    setPopup(false);
    setLoader(false);
  };

  // ------------------------
  // ------------------------
  // ------------------------
  const closePopup = (value) => {
    setIngredientEdit(null);
    setPopup(value);
    bodyScrollOverflowAuto();
  };

  const changeUnitsActive = (object, item, key, handleClick) => {
    if (key === 'unitIngredient') {
      setIngredientObject({
        ...object,
        [key]: item.unitText,
        text: object.textIngredientDefault + ' ' + item.unitText,
      });
    } else {
      setIngredientObject({
        ...object,
        [key]: item.unitText,
      });
    }
    handleClick(false);
  };
  const changeRoundinActive = (object, item, key1, key2, handleClick) => {
    setIngredientObject({
      ...object,
      [key1]: item.roundinText,
      [key2]: item.roundin,
    });

    handleClick(false);
  };

  const renderUnitsList = (unitsIngredient, ingredientObject, key, handleClick) => {
    return unitsIngredient.map((item) => {
      return (
        <div
          onClick={() => changeUnitsActive(ingredientObject, item, key, handleClick)}
          key={item.id}
          className={styles.units_text}>
          {item.unitText}
        </div>
      );
    });
  };

  const renderRoundinIngredientList = (
    roundinIngredients,
    ingredientObject,
    key1,
    key2,
    handleClick,
  ) => {
    return roundinIngredients.map((item) => {
      return (
        <div
          onClick={() => changeRoundinActive(ingredientObject, item, key1, key2, handleClick)}
          key={item.id}
          className={
            ingredientObject[key2] && ingredientObject[key2] === item.roundin
              ? styles.units_text + ' ' + styles.units_text_active
              : styles.units_text
          }>
          {item.roundinText}
        </div>
      );
    });
  };
  const onChangeInputIngredientName = (ingredientObject, value) => {
    setIngredientObject({
      ...ingredientObject,
      text: value + ' ' + ingredientObject.unitIngredient,
      textIngredientDefault: value,
    });

    if (!showSimilarData) {
      setShowSimilarData(true);
    }
  };
  const onChangeInputUnit = (ingredientObject, key, value) => {
    if (key === 'unitIngredient') {
      setIngredientObject({
        ...ingredientObject,
        [key]: value,
        text: ingredientObject.textIngredientDefault + ' ' + value,
      });
    } else {
      setIngredientObject({
        ...ingredientObject,
        [key]: value,
      });
    }
  };

  // Округляє число
  const roundinValue = (onChangeIngredientValue, roundinIngredientValue) => {
    // Округлення до найближчого кратного  5
    function roundToNearestFive(num) {
      return Math.round(num / 5) * 5;
    }
    // Округляє лише десяті до найближчого кратного 0.5
    function roundToNearestHalf(num) {
      return Math.round(num * 2) / 2;
    }
    // Округлення до найближчого кратного  5
    if (roundinIngredientValue === 5) {
      return roundToNearestFive(onChangeIngredientValue);
    }
    // Округляє до найближчого кратного 0.5
    if (roundinIngredientValue === 0.5) {
      return roundToNearestHalf(onChangeIngredientValue);
    }
    // округлює вниз (до меншого цілого)
    if (roundinIngredientValue === 'floor') {
      return Math.floor(onChangeIngredientValue);
    }
    // округлює вгору (до більшого цілого)
    if (roundinIngredientValue === 'ceil') {
      return Math.ceil(onChangeIngredientValue);
    }

    // округлює до десятків (0.2, 0.4, 0.6 .....)
    if (roundinIngredientValue === 'toFixed') {
      return Number(Number(onChangeIngredientValue).toFixed(1));
    }

    // округлює до найближчого цілого
    return Math.round(onChangeIngredientValue);
  };

  const countNutritionalValue = (
    ingredientObject,
    setIngredientObject,
    onChangeIngredientValue,
  ) => {
    let onChangeIngredientValueRoundin = roundinValue(
      onChangeIngredientValue,
      ingredientObject.roundinIngredientValue,
    );

    const сaloriesIngredient =
      (onChangeIngredientValueRoundin *
        Number(ingredientObject.valueCalculateForIngredient) *
        Number(ingredientObject.сaloriesProduct)) /
      Number(ingredientObject.valueIngredientDefault);

    const proteinIngredient =
      (onChangeIngredientValueRoundin *
        Number(ingredientObject.valueCalculateForIngredient) *
        Number(ingredientObject.proteinProduct)) /
      Number(ingredientObject.valueIngredientDefault);
    const fatsIngredient =
      (onChangeIngredientValueRoundin *
        Number(ingredientObject.valueCalculateForIngredient) *
        Number(ingredientObject.fatsProduct)) /
      Number(ingredientObject.valueIngredientDefault);
    const carbohydratesIngredient =
      (onChangeIngredientValueRoundin *
        Number(ingredientObject.valueCalculateForIngredient) *
        Number(ingredientObject.carbohydratesProduct)) /
      Number(ingredientObject.valueIngredientDefault);

    setIngredientObject({
      ...ingredientObject,
      onChangeIngredientValue: onChangeIngredientValue,
      onChangeIngredientValueRoundin: onChangeIngredientValueRoundin,
      сaloriesIngredient,
      proteinIngredient,
      fatsIngredient,
      carbohydratesIngredient,
    });
  };

  const addValue = (whatToDo, ingredientObject, setIngredientObject, targetValue) => {
    if (whatToDo === 'plus') {
      const newValue = Number(ingredientObject.onChangeIngredientValue) + 1;
      countNutritionalValue(ingredientObject, setIngredientObject, newValue);
    }
    if (whatToDo === 'minus' && Number(ingredientObject.onChangeIngredientValue) > 0) {
      const newValue = Number(ingredientObject.onChangeIngredientValue) - 1;
      countNutritionalValue(ingredientObject, setIngredientObject, newValue);
    }
    if ((whatToDo === 'targetValue' && Number(targetValue) >= 0) || targetValue === '') {
      const newValue = targetValue !== '' ? Number(targetValue) : targetValue;
      countNutritionalValue(ingredientObject, setIngredientObject, newValue);
    }
  };

  const getStringBasket = (ingredientObject) => {
    let value = '--';
    if (
      ingredientObject.onChangeIngredientValueRoundin != '' &&
      ingredientObject.onChangeIngredientValueRoundin &&
      ingredientObject.valueCalculateForBasket != ''
    ) {
      value = roundinValue(
        Number(ingredientObject.onChangeIngredientValueRoundin) *
          Number(ingredientObject.valueCalculateForBasket),
        ingredientObject.roundinProductBasketValue,
      );
    }
    return (
      ingredientObject.textBasketProductNameDefault +
      ' ' +
      value +
      ' ' +
      ingredientObject.unitBasket
    );
  };
  // Отримує строку для інгридієнта
  const getStringIngredient = (ingredientObject) => {
    const onChangeIngredientValueRoundin = ingredientObject.onChangeIngredientValueRoundin
      ? ingredientObject.onChangeIngredientValueRoundin
      : '--';

    return (
      ingredientObject.textIngredientDefault +
      ' ' +
      onChangeIngredientValueRoundin +
      ' ' +
      ingredientObject.unitIngredient
    );
  };

  return (
    <>
      <div className={styles.popup_wrapper}>
        <div className={styles.popup_contnent_wrapper}>
          <button className={styles.close_btn}>
            <CloseBtn handleClick={closePopup} />
          </button>
          Налаштування інгридієнта
          <div className={styles.ingredient_block}>
            Назва інгридієнта
            <div className={styles.input_wrapper}>
              <input
                className={styles.input_name}
                type="text"
                value={ingredientObject.textIngredientDefault}
                onChange={(e) => onChangeInputIngredientName(ingredientObject, e.target.value)}
              />

              {showSimilarData && (
                <SimilarData
                  searchArray={ingredientsArray}
                  itemSearch="textIngredientDefault"
                  textSearch={ingredientObject.textIngredientDefault}
                  handleClick={setShowSimilarData}
                  smallText_1="unitIngredient"
                  smallText_2="unitBasket"
                />
              )}
            </div>
            <div className={'df aic gap_10 mb_15'}>
              В чому вимірюється
              <div className={styles.unit_wrapper}>
                <input
                  className={styles.input_unit}
                  type="text"
                  value={ingredientObject.unitIngredient}
                  onChange={(e) =>
                    onChangeInputUnit(ingredientObject, 'unitIngredient', e.target.value)
                  }
                />
                <div onClick={() => setShowUnitsListIngredient(!showUnitsListIngredient)}>
                  <ListBtn />
                </div>

                {showUnitsListIngredient && (
                  <div className={styles.unit_list_wrapper}>
                    {renderUnitsList(
                      unitsIngredient,
                      ingredientObject,
                      'unitIngredient',
                      setShowUnitsListIngredient,
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={'mb_15'}>
              Як округляти кількість інгридієнта
              <div className={styles.roundingIngredient_wrapper}>
                <div className={styles.roundingIngredient}>
                  {ingredientObject.roundingIngredientText
                    ? ingredientObject.roundingIngredientText
                    : '--'}
                </div>
                <div onClick={() => setShowRoundingIngredientList(!showRoundingIngredientList)}>
                  <ListBtn />
                </div>

                {showRoundingIngredientList && (
                  <div className={styles.unit_list_wrapper}>
                    {renderRoundinIngredientList(
                      roundinIngredients,
                      ingredientObject,
                      'roundingIngredientText',
                      'roundinIngredientValue',
                      setShowRoundingIngredientList,
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={'df aic gap_10 mb_10'}>
              Чило для множення
              <input
                className={styles.input_valueCalculateForIngredient}
                type="number"
                min="0"
                value={ingredientObject.valueCalculateForIngredient}
                onChange={(e) =>
                  setIngredientObject({
                    ...ingredientObject,
                    valueCalculateForIngredient: e.target.value,
                  })
                }
              />
            </div>
            <div className={styles.table_macros_default}>
              <div className={'df aic p_2 bs_1'}>од/в</div>
              <div className={'df aic p_2 bs_1'}>Ккал</div>
              <div className={'df aic p_2 bs_1'}>Білки</div>
              <div className={'df aic p_2 bs_1'}>Жири</div>
              <div className={'df aic p_2 bs_1'}>Вугл</div>
              <div>
                <input
                  className={styles.input_table_value}
                  type="number"
                  min="0"
                  value={ingredientObject.valueIngredientDefault}
                  onChange={(e) =>
                    setIngredientObject({
                      ...ingredientObject,
                      valueIngredientDefault: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <input
                  className={styles.input_table_value}
                  type="number"
                  min="0"
                  value={ingredientObject.сaloriesProduct}
                  onChange={(e) =>
                    setIngredientObject({
                      ...ingredientObject,
                      сaloriesProduct: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <input
                  className={styles.input_table_value}
                  type="number"
                  min="0"
                  value={ingredientObject.proteinProduct}
                  onChange={(e) =>
                    setIngredientObject({
                      ...ingredientObject,
                      proteinProduct: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <input
                  className={styles.input_table_value}
                  type="number"
                  min="0"
                  value={ingredientObject.fatsProduct}
                  onChange={(e) =>
                    setIngredientObject({
                      ...ingredientObject,
                      fatsProduct: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <input
                  className={styles.input_table_value}
                  type="number"
                  min="0"
                  value={ingredientObject.carbohydratesProduct}
                  onChange={(e) =>
                    setIngredientObject({
                      ...ingredientObject,
                      carbohydratesProduct: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
          Налаштування корзіни
          <div className={styles.basket_block}>
            Назва продукта
            <div className={'df jcsb mb_20'}>
              <div className={styles.product_name}>
                {ingredientObject.textBasketProductNameDefault}
              </div>
              <div onClick={() => setShowProducsList(true)}>
                <ListBtn />
              </div>
            </div>
            <div className={'df aic gap_10 mb_15'}>
              В чому вимірюється
              <div className={styles.unit_wrapper}>
                <input
                  className={styles.input_unit}
                  type="text"
                  value={ingredientObject.unitBasket}
                  onChange={(e) =>
                    onChangeInputUnit(ingredientObject, 'unitBasket', e.target.value)
                  }
                />
                <div onClick={() => setShowUnitsListProducts(!showUnitsListProducts)}>
                  <ListBtn />
                </div>

                {showUnitsListProducts && (
                  <div className={styles.unit_list_wrapper}>
                    {renderUnitsList(
                      unitsProducts,
                      ingredientObject,
                      'unitBasket',
                      setShowUnitsListProducts,
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={'mb_15'}>
              Як округляти кількість продукта
              <div className={styles.roundingIngredient_wrapper}>
                <div className={styles.roundingIngredient}>
                  {ingredientObject.roundingProductBasketText
                    ? ingredientObject.roundingProductBasketText
                    : '--'}
                </div>
                <div
                  onClick={() => setShowRoundingProductBasketList(!showRoundingProductBasketList)}>
                  <ListBtn />
                </div>

                {showRoundingProductBasketList && (
                  <div className={styles.unit_list_wrapper}>
                    {renderRoundinIngredientList(
                      roundinIngredients,
                      ingredientObject,
                      'roundingProductBasketText',
                      'roundinProductBasketValue',
                      setShowRoundingProductBasketList,
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={'df aic gap_10 mb_10'}>
              Чило для множення
              <input
                className={styles.input_valueCalculateForProduct}
                type="number"
                min="0"
                value={ingredientObject.valueCalculateForBasket}
                onChange={(e) =>
                  setIngredientObject({
                    ...ingredientObject,
                    valueCalculateForBasket: e.target.value,
                  })
                }
              />
            </div>
          </div>
          Перевір чи все вірно
          <div className={styles.check_block}>
            <NutritionalValue activeIngredient={ingredientObject} />
            Що буде додано до інгридієнтів
            <div className={styles.check_tex}>{getStringIngredient(ingredientObject)}</div>
            Що буде додано до корзіни
            <div className={styles.check_tex}>{getStringBasket(ingredientObject)}</div>
            <div className={'mt_40 mb_30 df gap_5'}>
              <button
                onClick={() => addValue('minus', ingredientObject, setIngredientObject)}
                className={styles.onChange_value_btn + ' ' + styles.onChange_value_btn_minus}>
                -
              </button>
              <input
                min="0"
                type="number"
                className={styles.input_value}
                value={ingredientObject.onChangeIngredientValue}
                onChange={(e) =>
                  addValue(
                    'targetValue',
                    ingredientObject,
                    setIngredientObject,
                    e.target.value.trim(),
                  )
                }
              />
              <button
                onClick={() => addValue('plus', ingredientObject, setIngredientObject)}
                className={styles.onChange_value_btn + ' ' + styles.onChange_value_btn_plus}>
                +
              </button>
            </div>
          </div>
          <div className={styles.add_btn_wrapper}>
            <button className={styles.add_btn} onClick={() => addIngredients(ingredientObject)}>
              {ingredientEdit ? 'Редагувати' : 'Додати'}
            </button>
          </div>
        </div>
      </div>
      {showProducsList && (
        <ProductList
          products={products}
          ingredientObject={ingredientObject}
          setShowProducsList={setShowProducsList}
        />
      )}

      {loader && <LoaderPage />}
    </>
  );
}
